import { DiagramDefinition } from "../types";

export const m005Definition: DiagramDefinition = {
  id: "M-005",
  title: "Validation Layers Pipeline",
  description:
    "Solarch 4-stage data validation pipeline: API Request -> Schema Validation -> Record Upsert Form Validation -> Custom JS Hook Validation -> SQLite Transaction Insert.",
  viewBox: "0 0 900 180",
  nodes: [
    { id: "Request", kind: "client", label: "API Request", subtext: "Body / Params", position: [90, 90], size: [130, 48] },
    { id: "SchemaVal", kind: "service", label: "1. Schema Val", subtext: "Field Types", position: [260, 90], size: [140, 48] },
    { id: "FormVal", kind: "service", label: "2. Form Val", subtext: "Record Upsert", position: [440, 90], size: [140, 48] },
    { id: "HookVal", kind: "service", label: "3. JS Hook Val", subtext: "Custom Logic", position: [620, 90], size: [140, 48] },
    { id: "DBInsert", kind: "database", label: "SQLite Insert", subtext: "Bind Params", position: [800, 90], size: [125, 48] },
  ],
  edges: [
    { id: "e1", source: "Request", target: "SchemaVal", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "SchemaVal", target: "FormVal", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e3", source: "FormVal", target: "HookVal", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e4", source: "HookVal", target: "DBInsert", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
  ],
};
